/**
 * UnprofiledScreen - Awaiting approval screen
 * 
 * Displays message for users who are authenticated but not yet profiled
 */

import React from 'react';
import { useAuth } from '../hooks/useAuth';

const UnprofiledScreen = () => {
  const { logout, getUserClaims } = useAuth();
  const userClaims = getUserClaims();

  const handleLogout = () => {
    logout();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <div className="glass-panel glass-panel--tight w-full max-w-2xl">
        <div className="glass-panel__content text-center">
          <div className="text-warning text-6xl mb-6">⏳</div>
          <h1 className="text-3xl font-semibold text-glass-primary mb-4">
            Awaiting Admin Clearance
          </h1>

          <div className="text-glass-secondary mb-6 space-y-3">
            <p>
              Your identity is verified, but your access profile is still cooling in the approval chamber.
            </p>

            <p>
              Ping your platform administrator to accelerate the unlock.
            </p>

            {userClaims?.email && (
              <div className="glass-panel glass-panel--flush border border-glass mt-4">
                <div className="glass-panel__content py-3">
                  <p className="text-sm text-glass-primary">
                    <span className="text-glass-muted uppercase tracking-[0.2em] mr-1">Account</span>
                    {userClaims.email}
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className="glass-panel glass-panel--flush border border-glass mb-6 text-left">
            <div className="glass-panel__content">
              <h3 className="text-xs font-semibold text-glass-muted uppercase tracking-[0.28em] mb-3">
                What happens next
              </h3>
              <ul className="text-sm text-glass-secondary space-y-2">
                <li>• A platform admin reviews your telemetry and grants access</li>
                <li>• You receive an email the moment clearance is live</li>
                <li>• Return here to engage with the full platform</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button onClick={handleRefresh} className="btn btn-primary">
              Check Again
            </button>

            <button onClick={handleLogout} className="btn btn-secondary">
              Sign Out
            </button>
          </div>

          <div className="mt-6 pt-6 border-t border-glass">
            <p className="text-xs text-glass-muted">
              Need a faster unlock? Contact your IT administrator or platform support cell.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnprofiledScreen; 
